import { Typography } from '@mui/material';
import { useAppSelector } from 'app/hooks';

import { disciplinaInfoSelector } from '#modules/disciplinas/redux/disciplinaInfoSlice';

import { BoxInfo } from './styles';

export function PlanoEnsinoEmenta() {
  const disciplina = useAppSelector(disciplinaInfoSelector.disciplina);

  if (disciplina == null) return <></>;

  return (
    <BoxInfo id="ementa">
      <header>
        <Typography>EMENTA</Typography>
      </header>

      <div dangerouslySetInnerHTML={{ __html: disciplina.ementa }} />
    </BoxInfo>
  );
}
